<template>
	<button
		class="download-btn"
		@click="$emit('download-item')"
	>
		<img class="download-btn-img" :src="urlImage" :alt="alt" />
	</button>
</template>

<script>
	export default {
		name: 'download-btn',
		props: {
			alt: String,
			height: [Number, String],
			urlImage: String,
		},
	};
</script>

<style lang="scss" scoped>
	.download-btn {
		align-items: center;
		background-color: color(white) !important;
		border-radius: 2px !important;
		display: flex;
		height: 45px !important;
		justify-content: center;
		margin-left: 5px;
		width: 45px !important;

		&-img {
			height: 27px !important;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/diagnosis/download-btn.vue